import { ArrowUpRight } from "lucide-react";

const press = [
  {
    source: "LBB",
    title: "Binaifer Dulani in conversation",
    href: "https://lbbonline.com/news/binaifer-dulani",
  },
  {
    source: "Social Samosa",
    title: "Bad managers, bad for your career",
    href: "https://www.socialsamosa.com/guest-post/binaifer-dulani-on-bad-managers-bad-for-your-career-4596002",
  },
  {
    source: "ET BrandEquity",
    title: "A return to claim girlhood",
    href: "https://brandequity.economictimes.indiatimes.com/news/marketing/a-return-to-claim-girlhood/108251683",
  },
  {
    source: "exchange4media",
    title:
      "It's great to be a leader in fair weather, but difficult otherwise",
    href: "https://www.exchange4media.com/marketing-news/its-great-to-be-a-leader-in-fair-weather-but-difficult-otherwise-binaifer-dulani-139272.html",
  },
  {
    source: "exchange4media",
    title: "A creative trailblazer committed to inclusive creativity",
    href: "https://www.exchange4media.com/womens-day-news/binaifer-dulani-a-creative-trailblazer-committed-to-inclusive-creativity-141445.html",
  },
  {
    source: "Storyboard18",
    title:
      "Talented's Binaifer Dulani on the Cannes Lions See It Be It 2023 cohort",
    href: "https://www.storyboard18.com/quantum-brief/talenteds-binaifer-dulanis-experience-of-the-cannes-lions-see-it-be-it-2023-cohort-9421.htm",
  },
  {
    source: "Afaqs",
    title:
      "Talented's quest to transform designers into multidisciplinary creative leaders",
    href: "https://www.afaqs.com/news/advertising/talenteds-quest-to-transform-designers-into-multidisciplinary-creative-leaders-with-thinker-doer",
  },
];

export default function Press() {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative py-28 md:py-36 bg-[#FAFAF8] border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="reveal max-w-3xl mb-14 md:mb-20">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-5 font-medium">
            04. Press
          </div>
          <h2 className="font-display text-[#0A0A0A] text-[34px] sm:text-[44px] lg:text-[56px] font-medium leading-[1.08] tracking-[-0.025em]">
            In the press
          </h2>
          <p className="mt-6 text-[16px] md:text-[18px] text-[#3A3A3A] leading-[1.65] max-w-2xl">
            Articles, interviews, commentary, and coverage.
          </p>
        </div>

        <ul className="max-w-5xl border-t border-black/10">
          {press.map((p, i) => (
            <li
              key={p.href}
              data-testid={`press-item-${i}`}
              className="reveal border-b border-black/10"
              style={{ transitionDelay: `${i * 40}ms` }}
            >
              <a
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`press-link-${i}`}
                className="group grid grid-cols-12 items-baseline gap-3 sm:gap-6 py-5 md:py-7 transition-colors duration-300 hover:bg-black/[0.02]"
              >
                <span className="col-span-12 sm:col-span-3 md:col-span-3 text-[11px] uppercase tracking-[0.22em] text-[#6B6B6B] font-medium">
                  {p.source}
                </span>
                <span className="col-span-11 sm:col-span-8 md:col-span-8 font-display text-[#0A0A0A] text-[18px] sm:text-[20px] md:text-[22px] font-medium tracking-[-0.015em] leading-[1.35] group-hover:text-[#3A3A3A] transition-colors">
                  {p.title}
                </span>
                <span className="col-span-1 flex justify-end text-[#6B6B6B] group-hover:text-[#0A0A0A] transition-colors">
                  <ArrowUpRight
                    size={18}
                    className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
